type Link = {
    text: string,
    href: string,
};

export interface SecondaryHeaderState {
    logo: {
        svgLarge: string,
        svgSmall: string,
        svgLargeViewBox: string
        svgSmallViewBox: string
        alt: string,
        href: string,
    } | null,
    links: Array<Link> | null
    moreLinksText: string,
    pagePath: string,
}

export const secondaryHeaderReducer = (state:SecondaryHeaderState = {} as SecondaryHeaderState, action: {type:string}) => {
  switch (action.type) {
    default:
      return state;
  }
};
